import React from 'react';
import {
  Star,
  StarBorder
} from "@mui/icons-material";
import { 
  ListItem, 
  ListItemText 
} from '@mui/material';

import LoadingBox from "@components/input/LoadingBox";

interface Props {
  value: boolean;
  onChange: Function; 
  // icon?: string;
  size?: number;
  disabled?: boolean;
  name?: string;
  name_display?: () => React.ReactNode;
  tooltip?: string;
}

export default function StarBox({ 
  value,
  onChange,
  disabled = false,
  // icon = "",
  size = 0,
  tooltip = "",
  name = "",
  name_display
}: Props) {

  const renderName = () => {
    if (name.length > 0) {
      if (name === "Loading") {
        return (
          <LoadingBox />
        );
      } else {
        return (
          <ListItemText primary={ name } />
        );
      }
    }
    return null;
  }

  const size_str = `${size}px`;
  let checkbox: any;
  if (value) {
    if (size > 0) {
      checkbox = <Star style={{ width: size_str, height: size_str, color: (disabled ? "grey" : "") }} />;
    } else {
      checkbox = <Star style={{ color: (disabled ? "grey" : "") }} />;
    }
  } else if (size > 0) {
    checkbox = <StarBorder style={{ width: size_str, height: size_str, color: (disabled ? "grey" : "") }} />;
  } else { 
    checkbox = <StarBorder style={{ color: (disabled ? "grey" : "") }} />;
  }
  if (name.length > 0 || name_display) {
    const display = name_display ? name_display() : renderName();
    return (
      <ListItem 
        aria-controls="checkbox" aria-haspopup="false"
        title={tooltip} className="clickable"
        onClick={(event: any) => {
          if (!disabled && value !== null) {
            onChange(!value);
          }
        }}>
        { checkbox }
        { display }
      </ListItem>
    );
  } else {
    return (
      <span className="clickable"
        onClick={() => {
          if (!disabled && value !== null) {
            onChange(!value);
          }
        }}>
        { checkbox }
      </span>
    );
  }
}
